import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { UserListComponent } from './user-list/user-list.component'
import { MatIcon } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { Router, RouterModule } from '@angular/router'
import { RouteService } from '../../../services/route.service'
import { ROUTES } from '../../../constants/routes'
import { WindowService } from '../../../services/window.service'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-users',
  imports: [UserListComponent, MatButtonModule, MatIcon, RouterModule],
  templateUrl: './users.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './users.component.scss',
})
export class UsersComponent implements OnInit {
  router = inject(Router)
  routeService = inject(RouteService)
  windowService = inject(WindowService)
  translationService = inject(TranslationService)

  isMobileView: boolean = false

  ngOnInit() {
    this.windowService.isMobileView$.subscribe((isMobileView) => {
      this.isMobileView = isMobileView
    })

    const currentRoute = this.routeService.getUserRoutes(
      ROUTES.VITE_MARKETPLACE.title,
      `/admin/${ROUTES.USERS.path}`,
    )
    this.routeService.setRoute(currentRoute)
  }

  /**
   * Routes user to User Create screen
   */
  goToCreate() {
    this.router.navigate(['/admin/users/create'])
  }
}
